import { render, staticRenderFns } from "./consortium.vue?vue&type=template&id=64e673cd&scoped=true&"
import script from "./consortium.vue?vue&type=script&lang=js&"
export * from "./consortium.vue?vue&type=script&lang=js&"
import style0 from "./consortium.vue?vue&type=style&index=0&id=64e673cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e673cd",
  null
  
)

export default component.exports